module.exports = __webpack_public_path__ + "90ac0db1c7e5a61a70b5dc780bcdb7ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/settings/allRefund.png
// module id = 726
// module chunks = 0